import ListItem from './ListItem';

import './ListItem.scss';

export default ListItem;
